import createIcon from '../../createIcon';

/**
 * @component @name AlternateEmail
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMkM2LjQ4IDIgMiA2LjQ4IDIgMTJDMiAxNy41MiA2LjQ4IDIyIDEyIDIySDE3VjIwSDEyQzcuNjYgMjAgNCAxNi4zNCA0IDEyQzQgNy42NiA3LjY2IDQgMTIgNEMxNi4zNCA0IDIwIDcuNjYgMjAgMTJWMTMuNDNDMjAgMTQuMjIgMTkuMjkgMTUgMTguNSAxNUMxNy43MSAxNSAxNyAxNC4yMiAxNyAxMy40M1YxMkMxNyA5LjI0IDE0Ljc2IDcgMTIgN0M5LjI0IDcgNyA5LjI0IDcgMTJDNyAxNC43NiA5LjI0IDE3IDEyIDE3QzEzLjM4IDE3IDE0LjY0IDE2LjQ0IDE1LjU0IDE1LjUzQzE2LjE5IDE2LjQyIDE3LjMxIDE3IDE4LjUgMTdDMjAuNDcgMTcgMjIgMTUuNCAyMiAxMy40M1YxMkMyMiA2LjQ4IDE3LjUyIDIgMTIgMlpNMTIgMTVDMTAuMzQgMTUgOSAxMy42NiA5IDEyQzkgMTAuMzQgMTAuMzQgOSAxMiA5QzEzLjY2IDkgMTUgMTAuMzQgMTUgMTJDMTUgMTMuNjYgMTMuNjYgMTUgMTIgMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AlternateEmail = createIcon('AlternateEmail', [
  [
    'path',
    {
      d: 'M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22H17V20H12C7.66 20 4 16.34 4 12C4 7.66 7.66 4 12 4C16.34 4 20 7.66 20 12V13.43C20 14.22 19.29 15 18.5 15C17.71 15 17 14.22 17 13.43V12C17 9.24 14.76 7 12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C13.38 17 14.64 16.44 15.54 15.53C16.19 16.42 17.31 17 18.5 17C20.47 17 22 15.4 22 13.43V12C22 6.48 17.52 2 12 2ZM12 15C10.34 15 9 13.66 9 12C9 10.34 10.34 9 12 9C13.66 9 15 10.34 15 12C15 13.66 13.66 15 12 15Z',
      key: '1m7pvn',
    },
  ],
]);

export default AlternateEmail;
